package com.yogaaicoach.pages.dashboard

import com.yogaaicoach.common.ui.components.*
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

internal external interface LockedPageProps : Props {
    var onUpgradeClicked: () -> Unit
}

// Pixel-matched against LockedScreen.kt -> SubscriptionLockedOverlay.kt: a full-screen,
// non-interactive black@80% backdrop (fillMaxSize, unconstrained by PageLayout's 1000dp cap,
// since this replaces the dashboard content entirely rather than living inside it) with a
// centered Stars icon + headline + body text + a plain Material3 Button (not the custom
// PrimaryButton/CardButton used elsewhere in this app).
internal val LockedPage = FC<LockedPageProps> { props ->
    div {
        className = ClassName("locked-overlay")
        div {
            className = ClassName("locked-content")
            StarsIcon {}
            h2 { className = ClassName("locked-title"); +"Your Pro Access Has Ended" }
            p {
                className = ClassName("locked-subtitle")
                +"Upgrade to Pro to continue your personalized yoga journey and unlock all features."
            }
            button {
                className = ClassName("locked-upgrade-button")
                +"Upgrade to Pro"
                onClick = { props.onUpgradeClicked() }
            }
        }
    }
}
